import { useDispatch } from "react-redux";
import { sendMessage } from "../store/actions/WaitResult";

/**
 * кастомный хук для удобного использования функции отправки уведомления
 */
export default () => {
    const dispatch = useDispatch();
    return (...args) => dispatch(sendMessage(...args));
};